import React from "react"
import { MoonIcon, SunIcon } from "@heroicons/react/24/outline"
import { useTheme } from "@/lib/context/ThemeContext"

export const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme()

  return (
    <div
      className={
        (isDarkMode ? "bg-secondary-2" : "bg-transparent") +
        " w-14 h-8 flex items-center rounded-full p-1 cursor-pointer border-2 dark:border-secondary-11"
      }
      onClick={toggleTheme}
    >
      <div
        className={
          (isDarkMode ? "translate-x-6" : "translate-x-0") +
          " w-6 h-6 border-2 dark:border-secondary-11 rounded-full shadow-lg transform transition-transform p-px flex justify-center items-center"
        }
      >
        {isDarkMode ? (
          <MoonIcon className="w-4 h-4 dark:text-primary-10 text-light-2" />
        ) : (
          <SunIcon className="w-4 h-4 dark:text-primary-10 text-light-2" />
        )}
      </div>
    </div>
  )
}
